import { recoverConfigSchema } from "@redotech/redo-model/recover-config";
import * as z from "zod/v4";

export const createRecoverConfig = {
  name: "createRecoverConfig" as const,
  input: z.object({ name: z.string() }),
  output: recoverConfigSchema,
};
